import { createJSONRequest } from '@/api/create-request'

export const generateDescription = (type, data) => createJSONRequest({
  method: 'POST',
  url: `/api/generative/description?type=${type}`,
  data: data,
})
